import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityExportsApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDeletePracticalInformationExport = (
  options?: UseMutationOptions<void, unknown, string>
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, string>(
    ['delete-practical-information-export', assetId],
    async (exportId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await entityExportsApi.entityExportsControllerRemove(exportId, assetId);
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        queryClient.invalidateQueries(['fetch-practical-information-exports', assetId]);
        trackEvent('Export', 'delete', 'practical-information');
        options?.onSettled?.(data, error, variables, context);
      },
    }
  );
};
